import { OpenAPI, User, UserTgAdd, UserService, ApiError } from '../api';
import { getUserData } from './jwt';
// import { getUserData } from './jwt';

/**
 * authProvider types
 */
export type IAuthProvider = {
  login: (
    email: string, password: string
  ) => Promise<{ redirectTo?: string | boolean } | void | any>;
  loginTg: (
    user: any
  ) => Promise<{ redirectTo?: string | boolean } | void | any>;
  logout: () => Promise<void | false | string>;
  checkAuth: (params: any) => Promise<void>;
  checkError: (error: any) => Promise<void>;
  refresh: () => Promise<boolean>;
  getIdentity: () => Promise<User | null>;
  // getPermissions: (params: any) => Promise<string>;
  handleCallback?: () => Promise<void | any>;
  [key: string]: any;
};

const TOKEN_KEY = 'https://my.doooom.ru/token';
const REFRESH_TOKEN_KEY = 'https://my.doooom.ru/refreshToken';
const PERMISSIONS_KEY = 'https://my.doooom.ru/permissions';

const storage = {
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        console.error('Storage access error:', e);
        return null;
      }
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        console.error('Storage access error:', e);
      }
    }
  },
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        console.error('Storage access error:', e);
      }
    }
  }
};

export const authProvider: IAuthProvider = {
  login: async (email: string, password: string) => {
    try {
      const { token, refresh } = await UserService.loginUser(email, password);
      if (token && refresh) {
        storage.setItem(TOKEN_KEY, token);
        storage.setItem(REFRESH_TOKEN_KEY, refresh);
        OpenAPI.TOKEN = token;
        return true;
      }
      return false;
    } catch (e) {
      console.error('Login error:', e);
      return false;
    }
  },
  loginTg: async (user: any) => {
    try {
      const { token, refresh } = await UserService.loginTgUser({ user: user });
      if (token && refresh) {
        storage.setItem(TOKEN_KEY, token);
        storage.setItem(REFRESH_TOKEN_KEY, refresh);
        OpenAPI.TOKEN = token;
        return true;
      }
      return false;
    } catch (e) {
      console.error('Telegram login error:', e);
      return false;
    }
  },
  logout: async () => {
    try {
      // await UserService.logoutUser();
      storage.removeItem(REFRESH_TOKEN_KEY);
      storage.removeItem(TOKEN_KEY);
      storage.removeItem(PERMISSIONS_KEY);
      OpenAPI.TOKEN = undefined;
    } catch (e) {
      console.log(e);
    }
  },
  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      console.log("401/403")
      storage.removeItem(TOKEN_KEY);
      OpenAPI.TOKEN = undefined;
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    const token = storage.getItem(TOKEN_KEY);
    if (!token) {
      return Promise.reject();
    }
    OpenAPI.TOKEN = token;
    return UserService.checkUserToken();
  },
  refresh: async () => {
    try {
      const refreshToken = storage.getItem(REFRESH_TOKEN_KEY);
      if (!refreshToken) {
        console.warn('Refresh token is missing.');
        return false;
      }

      const { token, refresh } = await UserService.checkRefreshToken({ refresh_token: refreshToken });
      if (token && refresh) {
        storage.setItem(TOKEN_KEY, token);
        storage.setItem(REFRESH_TOKEN_KEY, refresh);
        OpenAPI.TOKEN = token;
        return true;
      } else {
        console.error('Failed to refresh tokens: no tokens returned.');
        return false;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      storage.removeItem(TOKEN_KEY);
      storage.removeItem(REFRESH_TOKEN_KEY);
      OpenAPI.TOKEN = undefined;
      return false;
    }
  },
  getIdentity: async () => {
    try {
      const token = storage.getItem(TOKEN_KEY);
      OpenAPI.TOKEN = token;
      if (!token) {
        console.error('No token found in storage');
        return null;
      }

      const user = getUserData(token);
      if (!user?.id) {
        console.error('Invalid token data');
        return null;
      }

      const data = await UserService.getUserByIs(user.id);
      return data;
    } catch (error: unknown) {
      if (error instanceof ApiError) {
        console.error('Error getting user data:', error.message);
        if (error && error.status === 401) {
          const refreshed = await authProvider.refresh();
          if (refreshed) {
            return authProvider.getIdentity();
          }
        }
      } else {
        console.error('Error getting user data:', error);
      }
      return null;
    }
  },
  //   getPermissions: () => {
  //     // const role = localStorage.getItem('https://my.doooom.ru/permissions');
  //     // console.log(role);
  //     return {''};
  //   },
};
